import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

/**
 * Universal service for working with harder to inject PLATFORM_ID.
 */
@Injectable({
  providedIn: 'root'
})
export class UniversalService {
  /**
   * Constructor for the universal service.
   */
  constructor(@Inject(PLATFORM_ID) private platformId: NonNullable<unknown>) {}

  /**
   * Is this code running in the browser or on the server?
   */
  isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  /**
   * Is this code running on the server?
   */
  isServer() {
    return !this.isBrowser();
  }
}
